import { Controller } from "@hotwired/stimulus";

// Confirms a form submission, but only when the watched field holds the value that makes
// it destructive. Turbo's data-turbo-confirm cannot express that condition -- it would
// also fire on bulk *activation*, which cancels nothing, and a dialog that appears when
// nothing is at stake is one people learn to click through.
export default class extends Controller {
  static values = { message: String, when: String };
  static targets = ["field"];

  submit(event) {
    // Fail closed. A missing target would otherwise throw before preventDefault runs,
    // letting the destructive submit through with no confirmation at all.
    if (this.hasFieldTarget && this.fieldSignal !== this.whenValue) return;
    if (!window.confirm(this.messageValue)) event.preventDefault();
  }

  // What this submit will turn the watched field into, as "true"/"false".
  //
  // A select carries that directly. A checkbox does not -- its `value` is the string Rails
  // renders ("1"), checked or not -- so read whether the submit actually turns it off:
  // `defaultChecked` is the state the server rendered, `checked` is the state being saved.
  // Reading both means re-saving an already-off switch does not ask again.
  get fieldSignal() {
    const field = this.fieldTarget;

    if (field.type !== "checkbox") return field.value;

    return field.defaultChecked && !field.checked ? "false" : "true";
  }
}
